export const exampleData = () => {
  return {
    impressions: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 2189, date: '2019-04-08'},
          {count: 2200, date: '2019-04-15'},
          {count: 2314, date: '2019-04-22'},
          {count: 2456, date: '2019-04-29'},
          {count: 2615, date: '2019-05-06'},
          {count: 2712, date: '2019-05-13'},
          {count: 2555, date: '2019-05-20'},
          {count: 2408, date: '2019-05-27'},
          {count: 2450, date: '2019-06-03'},
          {count: 2552, date: '2019-06-10'},
          {count: 2715, date: '2019-06-17'},
          {count: 2888, date: '2019-06-24'},
          {count: 3124, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 2552,
          totalCount: 33178,
        },
        data: [
          {count: 2189, date: '2019-04-08'},
          {count: 2200, date: '2019-04-15'},
          {count: 2314, date: '2019-04-22'},
          {count: 2456, date: '2019-04-29'},
          {count: 2615, date: '2019-05-06'},
          {count: 2712, date: '2019-05-13'},
          {count: 2555, date: '2019-05-20'},
          {count: 2408, date: '2019-05-27'},
          {count: 2450, date: '2019-06-03'},
          {count: 2552, date: '2019-06-10'},
          {count: 2715, date: '2019-06-17'},
          {count: 2888, date: '2019-06-24'},
          {count: 3124, date: '2019-07-01'},
        ],
      },
    },
  };
};
